import { Card, Grid, Switch, Typography } from '@mui/material';
import { CodJourney } from 'src/constants/assemblyJourneys';
import { ComponentTypes, DyProductSource } from 'src/interfaces';
import { lang } from 'src/utils';

import { ThemeMarker } from '../CustomerTriggeredEventsPage.styled';
import {
  IScreenOption,
  IUpdateComponents,
  UnionGlobalComponent,
} from './ScreenConfigSection.interface';
import { ScreenConfigSelect } from './ScreenConfigSelect';

export const GlobalComponentCard = ({
  component,
  screenOptions,
  handleCardChange,
  selectedState,
  isViewOnly = false,
}: {
  component: UnionGlobalComponent;
  screenOptions: IScreenOption[];
  handleCardChange: (updateComponents: IUpdateComponents[]) => void;
  selectedState: CodJourney;
  isViewOnly?: boolean;
}) => {
  const disableCOD = component.componentType === ComponentTypes.COD;
  const disableDYR =
    component.componentVariant === DyProductSource.DYR &&
    selectedState !== CodJourney.CUSTOMER_ENTERS_DRIVE_THRU;

  return (
    <Card variant="outlined" sx={{ borderRadius: '8px', marginBottom: 2 }}>
      <Grid container padding={1} justifyContent={'space-between'}>
        <Grid item alignSelf={'center'} display={'flex'} alignItems={'center'}>
          <Switch
            checked={!!component.enabled}
            disabled={isViewOnly || disableCOD || disableDYR}
            onChange={() => {
              handleCardChange([
                {
                  componentType: component.componentType,
                  componentVariant: component.componentVariant ?? '',
                  updateValue: {
                    enabled: !component.enabled,
                  },
                },
              ]);
            }}
          />
          <ThemeMarker
            style={{ backgroundColor: component.color, marginRight: '8px' }}
          />
          <Typography variant="body2">{component.label}</Typography>
        </Grid>

        <Grid item alignSelf={'center'} xs={4}>
          <ScreenConfigSelect
            label={lang.customerTriggeredEventsPage.screen}
            width="100px"
            value={component.screenSequence}
            onChange={(value) => {
              handleCardChange([
                {
                  componentType: component.componentType,
                  componentVariant: component.componentVariant ?? '',
                  updateValue: {
                    screenSequence: value as number,
                  },
                },
              ]);
            }}
            options={screenOptions}
            disabled={isViewOnly}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
